module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/essentials/sorority-essentials-02-large-1ed19bfcec4e950b40920cd6d871d0a4.jpg";